import { useQuery } from "@tanstack/react-query";
import { getAllStoreApiRequest } from "../../services";

export const useGetAllStoreApi = (isEnable?: any) => {
  const { data, isLoading } = useQuery({
    queryKey: ["all-store", isEnable],
    queryFn: () => getAllStoreApiRequest(),
    enabled: !!isEnable,
    placeholderData: (previousData) => previousData,
  });
  return {
    allStore: data,
    isLoading,
  };
};
